<template>
  <div class="task">
    <v-progress-circular v-if="this.saving"
      indeterminate
      color="green"
    ></v-progress-circular>

  <v-row>
    <v-col cols="12" sm="12" > 
      <v-card>
        <v-row align="center" class="list px-3 mx-auto">
          <v-col cols="4" sm="2">
            <v-select
              v-model="searchOption"
              :items="searchOptions"
              :label="langC.SearchBy"
              clearable
              @change="handleSearchOption"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field v-model="searchName" :label="langC.SearchBy"></v-text-field>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn small @click="page = 1; defaultInit();">
              {{langC.Search}}
            </v-btn>
          </v-col>
          <v-col cols="5" sm="4">
            <v-pagination
              v-model="page"
              :length="totalPages"
              total-visible="7"
              next-icon="mdi-menu-right"
              prev-icon="mdi-menu-left"
              @input="handlePageChange"
            ></v-pagination>
            
          </v-col>
          <v-col cols="4" sm="1" >
            Total:{{totalItems}}
          </v-col>
          <v-col cols="4" sm="1" >
            <v-select
              v-model="pageSize"
              :items="pageSizes"
              :label="langC.ItemsPerPage"
              @change="handlePageSizeChange"
            ></v-select>
        </v-col>
      </v-row>
     </v-card>
    </v-col>
  </v-row> 

  <v-row>
    <v-col cols="12" sm="12"> 
      <v-card>
        <v-card-title>
          {{ t.listTitle }}
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="mdi-magnify"
            :label="t.search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <v-data-table
            dense
            :headers="headers"
            :items="items"
            item-key="PrimarniKljuc"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="50"
            @click:row="openUtrosci"
          >

          <template v-slot:[`item.Kolicina`]="{ item }">
              <span>{{ localMoney(item.Kolicina) }}</span>
          </template>
          <template v-slot:[`item.BrojOtpremnice`]="{ item }">
              <span>{{ parseInt(item.BrojOtpremnice) }}</span>
          </template>
           <template v-slot:[`item.TvrtkaID`]="{ item }">
              <span>{{ parseInt(item.TvrtkaID) }}</span>
          </template>
           <template v-slot:[`item.ObjekatID`]="{ item }">
              <span>{{ parseInt(item.ObjekatID) }}</span>
          </template>
          <template v-slot:[`item.Datum`]="{ item }">
              <span>{{ localDate(item.Datum) }}</span>
          </template>

          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
        </v-data-table>
      </v-card>
     </v-col>
    </v-row>

    <!-- Dialog: Utrošak materijala za otpremnicu -->
    <v-dialog v-model="dialogUtrosci" max-width="900">
      <v-card>
        <v-card-title class="blue lighten-4">
          {{ t.materialConsumption }} - OTP{{ selectedBeton ? parseInt(selectedBeton.BrojOtpremnice) : '' }}
          <v-spacer></v-spacer>
          <v-btn v-if="selectedBeton" text small color="primary" @click="utrosciToExcel(selectedBeton)">{{ t.toExcel }}</v-btn>
          <v-btn icon @click="dialogUtrosci = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-progress-circular v-if="loadingUtrosci" indeterminate color="green"></v-progress-circular>

          <div v-if="!loadingUtrosci && selectedBeton">
            <v-row class="mb-2">
              <v-col cols="12" sm="4"><b>{{ t.recipe }}:</b> {{ selectedBeton.Receptura }}</v-col>
              <v-col cols="12" sm="4"><b>{{ t.quantity }}:</b> {{ localMoney(selectedBeton.Kolicina) }} m3</v-col>
              <v-col cols="12" sm="4"><b>{{ t.date }}:</b> {{ localDate(selectedBeton.Datum) }}</v-col>
              <v-col cols="12" sm="4"><b>{{ t.customer }}:</b> {{ selectedBeton.Kupac }}</v-col>
              <v-col cols="12" sm="4"><b>{{ t.constructionSite }}:</b> {{ selectedBeton.Gradiliste }}</v-col>
              <v-col cols="12" sm="4"><span v-if="selectedBeton.Storno" class="red--text font-weight-bold">{{ t.storno }}</span></v-col>
            </v-row>

            <div v-for="grupa in utrosciGrupeZa(selectedBeton)" :key="grupa.naziv">
              <div v-if="grupa.stavke.length" class="mt-3">
                <div class="text-subtitle-1 font-weight-bold">{{ grupa.naziv }}</div>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">{{ t.article }}</th>
                        <th class="text-left">{{ t.codeShort }}</th>
                        <th class="text-right">{{ t.targetShort }}</th>
                        <th class="text-right">{{ t.dosedShort }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(s, i) in grupa.stavke" :key="i">
                        <td>{{ s.naziv }}</td>
                        <td>{{ s.sifra }}</td>
                        <td class="text-right">{{ localMoney(s.zadano) }}</td>
                        <td class="text-right">{{ localMoney(s.dozirano) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>

            <div class="mt-3">
              <div class="text-subtitle-1 font-weight-bold">{{ t.water }}</div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-right">{{ t.targetShort }}</th>
                      <th class="text-right">{{ t.dosedShort }}</th>
                      <th class="text-right">{{ t.waterAdded }}</th>
                      <th class="text-right">{{ t.waterCorrection }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-right">{{ localMoney(selectedBeton.VodaZadano) }}</td>
                      <td class="text-right">{{ localMoney(selectedBeton.VodaDozirano) }}</td>
                      <td class="text-right">{{ localMoney(selectedBeton.VodaNaknadno) }}</td>
                      <td class="text-right">{{ localMoney(selectedBeton.VodaKorekcija) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BetonService from '@/services/BetonService'
import moneyFormat from '@/snippets/moneyFormat'
import { utrosciRows, utrosciColumns, otpremniceColumns, otpremniceRows } from '@/snippets/betonUtrosci'
import { betonT } from '@/snippets/betonLang'
import xlsx from 'json-as-xlsx'

export default {
  name: 'betonlist',
  data () {
    return {
      documentName: '',
      documentNameLoc: '',
      docside: 0,
      msg: '',
      items: [],
      max25chars: (v) => v.length <= 25 || 'Input too long!',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        MLType: 1
      },
      columns: [],
      rows: [],
      lang: {},
      langC: {},
      saving: false,
      searchName: "",
      page: 1,
      totalPages: 0,
      pageSize: 30,
      pageSizes: [10, 30, 50],
      searchOption: '',
      searchOptions: [],
      totalItems: 0,
      bookTypeSelected: {},
      show: 0,
      dialogUtrosci: false,
      selectedBeton: null,
      loadingUtrosci: false
    }
  },
  async mounted () {
    this.defaultInit()
  },
  methods: {
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    localDate(dateToFormat) {
       return this.$moment(dateToFormat).format('DD.MM.YYYY')
    },
    async openUtrosci(item) {
      this.dialogUtrosci = true
      this.loadingUtrosci = true
      this.selectedBeton = null
      try {
        const res = await BetonService.showOne(item.id)
        this.selectedBeton = res.data && res.data.beton ? res.data.beton : item
      } catch (err) {
        console.log('Error openUtrosci ', err)
        this.selectedBeton = item
      }
      this.loadingUtrosci = false
    },
    utrosciGrupeZa(beton) {
      return [
        { naziv: this.t.aggregates, stavke: this.napuniGrupu(beton, 'Agr', 8) },
        { naziv: this.t.cements, stavke: this.napuniGrupu(beton, 'Cem', 6) },
        { naziv: this.t.additives, stavke: this.napuniGrupu(beton, 'Adi', 6) }
      ]
    },
    napuniGrupu(beton, prefix, count) {
      const stavke = []
      if (!beton) return stavke
      for (let i = 1; i <= count; i++) {
        const naziv = beton[`${prefix}${i}NazivArtikla`]
        const sifra = beton[`${prefix}${i}SifraArtikla`]
        const zadano = parseFloat(beton[`${prefix}${i}Zadano`]) || 0
        const dozirano = parseFloat(beton[`${prefix}${i}Dozirano`]) || 0
        if ((naziv && naziv.trim() !== '') || zadano !== 0 || dozirano !== 0) {
          stavke.push({ naziv: naziv || '', sifra: sifra || '', zadano, dozirano })
        }
      }
      return stavke
    },
    utrosciToExcel(beton) {
      if (!beton) return
      const lang = this.$store.state.language
      const t = betonT(lang)
      const broj = parseInt(beton.BrojOtpremnice)
      const data = [
        {
          sheet: t.sheetDeliveryNote,
          columns: otpremniceColumns(lang),
          content: otpremniceRows([beton], this.localDate, lang)
        },
        {
          sheet: t.sheetMaterialConsumption,
          columns: utrosciColumns(lang),
          content: utrosciRows([beton], this.localDate, lang)
        }
      ]
      xlsx(data, { fileName: t.deliveryNote + '_' + broj, extraLength: 3, writeOptions: {} })
    },
    async defaultInit() {
      this.$store.dispatch('seteditItem', 0)
      this.headers = []
      this.searchOptions = []
       
      const query = this.setQuery()
      if (query.searchItem && this.searchName) {
        query.searchName =  this.searchName.trim()
        await this.$store.dispatch('setOnPage', query)
      }
      if (query.searchItem && query.searchName) {
        this.searchOption = query.searchItem
        this.searchName = query.searchName 
      }
      this.saving = true
 
      await BetonService.indexlist(query)
      .then(res => {
        console.log("🚀 ~ res", res)
        this.items = res.data.betoni ? res.data.betoni : []
        this.totalItems = res.data.totalPages
        this.totalPages = parseInt(res.data.totalPages / this.pageSize) + 1
      })
      .catch(err => {
        this.havealert = !this.havealert
        this.havemssgalert = 'Error' + err
      })
      this.saving = false
      this.documentName = this.$store.state.documentActiv
      this.documentNameLoc = this.$store.state.documentActivLoc

      this.headers.push(
        { text: 'Datum', align: 'left', sortable: true, value: 'Datum', width: '50px' },
        { text: 'Vrijeme', align: 'left', sortable: true, value: 'Vrijeme', width: '50px' },
        { text: 'Kolicina', align: 'left', sortable: true, value: 'Kolicina', width: '90px' },
        {
          text: 'Tvrtka ID', align: 'left', sortable: true, value: 'TvrtkaID', width: '60px'
        },
        { text: 'Tvrtka', align: 'center', value: 'Tvrtka', width: '200px' },
        { text: 'Objekat ID', align: 'left', sortable: true, value: 'ObjekatID', width: '50px' },
        { text: 'Objekat', align: 'center', value: 'Objekat', width: '200px' },
        { text: 'Broj Otpremnice', align: 'center', value: 'BrojOtpremnice', width: '100px' },
        { text: 'Broj Naloga', align: 'center', value: 'BrojNaloga', width: '100px' },
        { text: 'Receptura', align: 'left', sortable: true, value: 'Receptura', width: '130px' },
        { text: 'Sifra Artikla', align: 'left', sortable: true, value: 'SifraArtikla', width: '100px' },
        { text: 'Vrsta Betona', align: 'left', sortable: true, value: 'VrstaBetona', width: '100px' },
        { text: 'Kupac', align: 'left', sortable: true, value: 'Kupac', width: '250px' },
        { text: 'Kupac OIB', align: 'center', value: 'KupacOIB', width: '100px' },
        { text: 'Gradiliste', align: 'center', value: 'Gradiliste', width: '150px' },
        { text: 'Vozac', align: 'left', sortable: true, value: 'Vozac', width: '150px' },
        { text: 'RegOzn', align: 'left', sortable: true, value: 'RegOzn', width: '100px' },
        { text: 'DbId', value: 'id', width: '60px' }
      )
      this.searchOptions.push(
        {
          text: 'Tvrtka ID', align: 'left', sortable: true, value: 'TvrtkaID', width: '60px'
        },
        { text: 'Objekat ID', align: 'left', sortable: true, value: 'ObjekatID', width: '50px' },
        { text: 'Broj Otpremnice', align: 'center', value: 'BrojOtpremnice', width: '100px' },
        { text: 'Kupac', align: 'left', sortable: true, value: 'Kupac', width: '50px' },
        { text: 'Kupac OIB', align: 'center', value: 'KupacOIB', width: '100px' },
        { text: 'Gradiliste', align: 'center', value: 'Gradiliste', width: '100px' },
      )
    },
    async navigateTo (params) {
      console.log("🚀 ~ file: BetonList.vue ~ line 220 ~ navigateTo ~ params", params)
      const index = this.items.indexOf(params)
      await this.$store.dispatch('setDocumentActivHead', this.items[index])
      await this.$store.dispatch('seteditItem', 1)
      this.$store.dispatch('setretPath', 'salarie')
      await this.$store.dispatch('setDatabaseDocID', params.id)
      // this.$router.push({
      //   name: 'salariedetail'
      // })
    },

    async handlePageChange(value) {      
      const query = this.$store.state.onPage
      query.page = value - 1;
      this.page = value
      await this.$store.dispatch('setOnPage', query)
      this.defaultInit();
    },

    async handlePageSizeChange(size) {
      const query = this.$store.state.onPage
      query.pageSize = size;
      query.page = 1;
      this.pageSize = size
      await this.$store.dispatch('setOnPage', query)
      this.defaultInit();
    },

    async handleSearchOption(option) {
      this.searchOption = option
      const query = this.$store.state.onPage
      query.searchItem = option
      query.page = 0
      await this.$store.dispatch('setOnPage', query)
    },

    setQuery() {
      const haveOnPage = this.$store.state.onPage
      const query = {}
      query.searchName = haveOnPage.searchName ? haveOnPage.searchName.trim() : null
      query.page = haveOnPage.page ? haveOnPage.page : 0
      this.page  = query.page + 1
      query.pageSize = haveOnPage.pageSize ? haveOnPage.pageSize : 30
      this.pageSize = query.pageSize
      query.searchItem = haveOnPage.searchItem ? haveOnPage.searchItem : null
      return query
    },
    async defaultQuery() {
      const query = {}
      // if (this.$store.state.companyid) {
      //   query.CompanyId = this.$store.state.companyid
      // }
      query.searchName = null
      query.page =  0
      query.pageSize =  30
      query.searchItem =  null
      await this.$store.dispatch('setOnPage', query)
      this.searchName = ""
      this.page = 1
      this.totalPages = 0
      this.pageSize = 30
      this.mainQuery = query
    },
    async initAgain () {
      this.defaultQuery()
      this.defaultInit()
    }
  },
  computed: {
    t () {
      return betonT(this.$store.state.language)
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
